import { UseQueryResult } from '@tanstack/react-query';
import { Link } from '../../../../../../Resource/Types';
import { useQueryWithDecoder } from '../../../../../../UseQueryWithDecoder';
import { filterOptionsResourceDecoder } from './FilterOptionsDecoder';
import { FilterOptionsPayload } from './FilterOptionsTypes';

const FILTER_OPTIONS_STALE_TIME = 15 * 60 * 1000; // 15 minutes

export const useFilterOptions = (
  links: ReadonlyArray<Link>,
): UseQueryResult<FilterOptionsPayload | undefined, Error> => {
  return useQueryWithDecoder('filter_options', links, filterOptionsResourceDecoder, {
    staleTime: FILTER_OPTIONS_STALE_TIME,
  });
};
